import React, { useEffect, useState, useMemo } from "react";
import "../styles/remixicon.css";
import "react-tabs/style/react-tabs.css";
import "swiper/css";
import "swiper/css/bundle";

// Chat Styles
import "../styles/chat.css";
// Globals Styles
import "../styles/globals.css";
// Rtl Styles
import "../styles/rtl.css";
// Dark Mode Styles
import "../styles/dark.css";
// Theme Styles
import { getTheme } from "../styles/theme";

import { ThemeProvider, CssBaseline } from "@mui/material";
import Layout from "@/components/Layouts/Layout";
import { checkIsNotLogged } from '@/utils/authCheck';  

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProviderWrapper } from "@/contexts/ThemeContext";
import { useThemeMode } from "@/contexts/ThemeContext";
import { ChatSocketProvider } from "@/contexts/ChatSocketContext";

import Head from 'next/head'; 

import { usePullToRefresh } from '@/utils/usePullToRefresh';
import { PWALoader } from "@/utils/PWALoader"; 

function MyApp({ Component, pageProps }) {
	return (
		<>
                    <ThemeProviderWrapper>
                         <PWALoader>
                              <InnerApp />
                         </PWALoader>
                    </ThemeProviderWrapper>
		</>
	);

     function InnerApp() {
          usePullToRefresh(() => {
               window.location.reload();
          });

          const { isDarkMode } = useThemeMode();
          const muiTheme = useMemo(() => getTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);

          useEffect(() => {
               const inputs = document.querySelectorAll('input, textarea, select');
                    inputs.forEach(input => {
                    input.setAttribute('autocomplete', 'off');
                    input.setAttribute('autocorrect', 'off');
                    input.setAttribute('autocapitalize', 'off');
                    input.setAttribute('spellcheck', 'false');
               });
          }, []);

          return (
               <ThemeProvider theme={muiTheme}>
                    <Head>
                              
                         {/* PWA primary color */}
                         <meta name="theme-color" content={isDarkMode ? "#0d1015":"#fff"} />

                         {/* Viewport fix for iOS */}
                         <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, viewport-fit=cover" />

                         {/* Manifest & Icons */}
                         <link rel="manifest" href="/manifest.json" />
                         <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                         {/* iOS specific */}
                         <meta name="apple-mobile-web-app-capable" content="yes" />
                         <meta name="apple-mobile-web-app-status-bar-style" content="default" />
                         <meta name="apple-mobile-web-app-title" content="ALL CONSULTING LASCU" />
                         <meta name="format-detection" content="telephone=no"/>
                         {/* Android Chrome */}
                         <meta name="mobile-web-app-capable" content="yes" />

                         {/* Language and direction */}
                         <meta name="lang" content="ro" />
                         <meta name="direction" content="ltr" />

                         {/* Windows Tiles (optional) */}
                         <meta name="msapplication-TileColor" content="#f0a000" />
                         <meta name="msapplication-TileImage" content="/icon512_rounded.png" />

                         {/* Favicon (browser tab) */}
                         <link rel="icon" type="image/png" href="/favicon-96x96.png" sizes="96x96" />
                         <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
                         <link rel="shortcut icon" href="/favicon.ico" />

                         {/* Maskable icon for Android */}
                         <link rel="mask-icon" href="/icon512_maskable.png" color="#f0a000" />

                         {/* Description (optional for SEO/PWA) */}
                         <meta name="description" content="Aplicația ALL CONSULTING LASCU - transport și consultanță profesională" />
                    
               </Head>
               <CssBaseline />
               <ChatSocketProvider>
                    <Layout>
                         <ToastContainer />
                         <Component {...pageProps} />
                    </Layout>
               </ChatSocketProvider>
               </ThemeProvider>
          );
     }
}

export default MyApp;
